import React from 'react';
import { SectionWrapper } from './Shared';
import { Smartphone, Activity, Flame } from 'lucide-react';
export const ProblemSection = () => {
  const problems = [{
    icon: <Smartphone className="w-8 h-8 text-gold-400" data-id="element-171" />,
    title: 'Pantallas',
    desc: 'Destruyen tu ritmo circadiano y tu sueño profundo.'
  }, {
    icon: <Activity className="w-8 h-8 text-gold-400" data-id="element-172" />,
    title: 'Estrés Crónico',
    desc: 'Devora tus hormonas masculinas y eleva tu cortisol.'
  }, {
    icon: <Flame className="w-8 h-8 text-gold-400" data-id="element-173" />,
    title: 'Comida Inflamatoria',
    desc: 'Inflama tus células y bloquea tu producción de energía.'
  }];
  return <SectionWrapper data-id="element-174">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-175">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight mb-6" data-id="element-176">
          No es tu edad. <br data-id="element-177" />
          <span className="text-zinc-500" data-id="element-178">No es que "ya no seas joven".</span>
        </h2>
        <p className="text-xl text-zinc-300" data-id="element-179">
          Es que tu biología masculina está bajo ataque constante. Vivimos en un
          entorno diseñado para apagar tu motor.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-16" data-id="element-180">
        {problems.map((prob, idx) => <div key={idx} className="bg-dark-800 border border-white/5 p-8 rounded-2xl text-center hover:border-gold-500/30 transition-colors" data-id="element-181">
            <div className="w-16 h-16 mx-auto bg-dark-900 rounded-full flex items-center justify-center mb-6 border border-white/5 shadow-inner" data-id="element-182">
              {prob.icon}
            </div>
            <h3 className="font-oswald text-2xl font-bold text-white mb-3 uppercase" data-id="element-183">
              {prob.title}
            </h3>
            <p className="text-zinc-400" data-id="element-184">{prob.desc}</p>
          </div>)}
      </div>

      <div className="bg-gold-500/10 border border-gold-500/20 rounded-2xl p-8 md:p-10 text-center max-w-4xl mx-auto" data-id="element-185">
        <p className="text-lg md:text-xl text-gold-100 font-medium" data-id="element-186">
          Estás atrapado en un ciclo de cortisol elevado y energía por el suelo.
          Si no cambias la señal que recibe tu cuerpo hoy mismo, ese "apagón"
          será permanente.
        </p>
      </div>
    </SectionWrapper>;
};